import { Alert, Button, Modal, Text } from '@viapeople/components'
import type React from 'react'

export interface EvaluationDetailItem {
	evaluationId: string
	participantId: string
	firstName: string
	lastName: string
	formId: string | null
	reviewerCount: number
	isRemoved: boolean
	removalMode: 'display' | 'hide' | null
	tasks: {
		id: string
		cycleStepDisplayName: string
		evaluatorId: string
		evaluatorFirstName: string | null
		evaluatorLastName: string | null
		calculatedRole: string | null
	}[]
	customFields: Record<string, string> | null
}

interface EvaluationDetailModalProps {
	isOpen: boolean
	onClose: () => void
	evaluation: EvaluationDetailItem
}

export const EvaluationDetailModal: React.FC<EvaluationDetailModalProps> = ({ isOpen, onClose, evaluation }) => {
	const participantName = `${evaluation.firstName} ${evaluation.lastName}`

	return (
		<Modal isOpen={isOpen} onClose={onClose} title={participantName} className='w-120'>
			<div className='flex flex-col gap-4'>
				{evaluation.isRemoved && (
					<Alert variant='info' message='This participant was removed from the cycle. Data is read-only.' />
				)}

				<div className='flex flex-col gap-2'>
					<div className='flex justify-between'>
						<Text variant='small' className='text-neutral-500'>
							Reviewers
						</Text>
						<Text variant='small' weight='semibold'>
							{evaluation.reviewerCount}
						</Text>
					</div>

					{evaluation.tasks.length > 0 && (
						<div className='flex flex-col gap-1'>
							<Text variant='small' className='text-neutral-500'>
								Tasks
							</Text>
							{evaluation.tasks.map((task) => (
								<div key={task.id} className='flex items-center justify-between p-2 border rounded-md bg-neutral-50'>
									<Text variant='small'>{task.cycleStepDisplayName}</Text>
									{task.evaluatorFirstName && (
										<Text variant='xsmall' className='text-neutral-500'>
											{task.evaluatorFirstName} {task.evaluatorLastName}
										</Text>
									)}
								</div>
							))}
						</div>
					)}
				</div>

				<div className='flex justify-end'>
					<Button variant='secondary' onClick={onClose}>
						Close
					</Button>
				</div>
			</div>
		</Modal>
	)
}
